export const LEGENDS = [
  {
    keyId: "planning_evaluation",
    label: "Planning and Scheduling",
  },
  {
    keyId: "process_evaluation",
    label: "Process Evaluation",
  },
  {
    keyId: "technical_approved",
    label: "Technical Approved",
  },
  {
    keyId: "technical_approved_with_restrictions",
    label: "Technical Approved With Restrictions",
  },
  {
    keyId: "technical_rejected",
    label: "Technical Rejected",
  },
  {
    keyId: "missing_information",
    label: "Missing Information",
  },
  {
    keyId: "request_extra_information",
    label: "Request Extra Information",
  },
  {
    keyId: "approved",
    label: "Approved",
  },
  {
    keyId: "rejected",
    label: "Rejected",
  },
];